export default __webpack_public_path__ + "static/media/voicesteps.f43252b1.png";